import AdminLayout from '@/layouts/admin/AdminLayout.vue'
import {useAuthentication} from '@/services/useAuthentication.ts'

const { beforeEnter } = useAuthentication()

export default [
  {
    path: '/admin',
    beforeEnter,
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/DashboardPage.vue'),
      },
      {
        path: 'utenti',
        name: 'utenti',
        meta: {
          title: 'Utenti',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/UsersPage.vue'),
      },
      {
        path: 'clienti',
        name: 'clienti',
        meta: {
          title: 'Clienti',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/CustomersPage.vue'),
      },
      {
        path: 'profili',
        name: 'profili',
        meta: {
          title: 'Profili',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/ProfilesPage.vue'),
      },
      {
        path: 'cantieri/:clienteId?',
        name: 'cantieri',
        meta: {
          title: 'Cantieri',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/CantieriPage.vue'),
      },
      {
        path: 'cantieri/:cantiereId/parchi',
        name: 'parchi',
        meta: {
          title: 'Categorie Parco',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/ParchiPage.vue'),
      },
      {
        path: 'vetture',
        name: 'vetture',
        meta: {
          title: 'Vetture',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/VetturePage.vue'),
      },
      {
        path: 'lavori',
        name: 'lavori',
        meta: {
          title: 'Lavori',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/JobsPage.vue'),
      },
      {
        path: 'fatture',
        name: 'fatture',
        meta: {
          title: 'Fatture',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/FatturePage.vue'),
      },
    ],
  },
]
